import React from 'react'
import styles from '../../styles/solution.module.css';

interface SolutionUseCasesCardProps {
    title: string;
    content: string;
    icon: string;
}

const SolutionUseCasesCard: React.FC<SolutionUseCasesCardProps> = ({ title, content, icon }) => {
    return (
        <div className={styles.card}>
            <div>
                <img src={icon} alt={title} />
            </div>
            <div>
                <span>{title}</span>
                <span>{content}</span>
            </div>
        </div>
    )
}

export default SolutionUseCasesCard;
